import React from 'react';
import { I18n } from 'react-redux-i18n';
import { PopoverHeader, UncontrolledPopover } from 'reactstrap';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

class WikiHelp extends React.PureComponent {
  render() {
    const { wikiPath = '', wikiBaseUrl } = this.props;
    return (
      <div className="mb-3 text-grey">
        <a
          href={`${wikiBaseUrl}${wikiPath}`}
          rel="noopener noreferrer"
          target="_blank"
          id="popoverClickWiki"
          style={{ color: '#f17b1e', marginLeft: '5px' }}
        >
          <i className="fa fa-question-circle" />
          <UncontrolledPopover trigger="hover" placement="top" target="popoverClickWiki">
            <PopoverHeader>
              {I18n.t('BEE2599' /* SZ Soluções Wiki */)}
            </PopoverHeader>
          </UncontrolledPopover>
        </a>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  wikiBaseUrl: state.app.beeWikiHost,
});

export default connect(mapStateToProps)(withRouter(WikiHelp));
